import { useEffect, useState, useMemo } from "react";
import { motion } from "framer-motion";
import { DatePicker, Picker } from "antd-mobile";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import moment from "moment";
import payment_icon from "../../images/charge/payment_icon.png";
import styles from "./index.module.scss";
import { getChargeListApi } from "../../http/request";
import { modalAlert } from "../../component/Modal/index";
import { useStore } from "../../store/store";
import Empty from "../../component/empty/index";
import {useNavigate} from 'react-router-dom'
const variants = {
  container: {
    animate: {
      transition: {
        staggerChildren: 0.1,
      },
    },
  },
  card: {
    initial: {
      opacity: 0,
      x: -50,
    },

    animate: {
      opacity: 1,
      x: 0,
    },
  },
};

export default function Index() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate()
  const [visible1, setVisible1] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [time, setTime] = useState<string>(moment().format("YYYY"));
  const [meter, setMeter] = useState(["1"]);
  const [list, setList] = useState<Record<string, any>[]>([]);
  const [monitorId, setMonitorId] = useState();
  const [meterName, setMeterName] = useState<string>("");
  const [meterOptions, setMeterOptions] = useState<any[]>();
  const { nkdSid, meterList, buildingIsDisplayed } = useStore((state) => state);
  const getChargeList = async () => {
    const res = await getChargeListApi({
      nkdSid: nkdSid,
      year: time,
      monitorId: monitorId,
    });
    if (res.data.code == 0) {
      setList(res.data.list);
      return;
    }
  };
  /**
   * @description 获取表计类型
   */
  const coverMeterLabel = (label: string) => {
    let name = "";
    switch (label) {
      case "电表":
        name = t("EL");
        break;
      case "冷水表":
        name = t("LS");
        break;
      case "热水表":
        name = t("RS");
        break;
      default: {
      }
    }
    return name;
  };
  useMemo(() => {
    if (buildingIsDisplayed !== 0 && time && monitorId){
      getChargeList();
    }
  }, [time, monitorId]);
  const listElement = useMemo(() => {
    let listdom: any;
    if (list.length > 0) {
      listdom = list.map((item) => {
        return (
          <motion.div
            key={item.orderno}
            variants={variants.card}
            className={styles.item_view}
          >
            <img
              src={payment_icon}
              style={{ width: "42px", height: "41.5px" }}
              alt=""
            />
            <div className={styles.room_view}>
              <p>{i18n.language == "en" ? item.roomnameen : item.roomname}</p>
              {/*  <p className={styles.room_center}>{item.chargeway}</p> */}
              <span>{item.chargetime}</span>
            </div>
            <div
              className={classNames(styles.room_view, {
                [styles.money_view]: true,
              })}
            >
              <p style={{ color: "#00B676" }}>
                {item.chargeamount} {t("MONETARY_UNIT")}
              </p>
              {/*  <p className={styles.room_center}>{item.clientname}</p> */}
              <span>{coverMeterLabel(item.energytype)}</span>
            </div>
          </motion.div>
        );
      });
    } else {
      listdom = <Empty description={t("ZWSJ")} />;
    }
    return (
      <motion.div
        initial="initial"
        animate="animate"
        variants={variants.container}
        className={styles.content_container}
      >
        {listdom}
      </motion.div>
    );
  }, [list]);
  useEffect(() => {
    if (!nkdSid) {
      navigate('/login')
      return
    }
    document.title = t("JFLS");
    if (buildingIsDisplayed !== 0 && meterList.length > 0) {
      const options = meterList.map((item: Record<string, any>) => {
        return {
          value: item.monitorid,
          label: coverMeterLabel(item.energyType),
        };
      });
      setMonitorId(options[0].value);
      setMeterName(options[0].label);
      setMeterOptions([options]);
    }
  }, []);
  return (
    <div className={styles.main_container}>
      <div className={styles.background_line}>
        <div className={styles.time_view}>
          <div
            className={styles.time}
            onClick={() => {
              setVisible1(true);
            }}
          >
            <p style={{ color: "#010101" }}>{time} </p>
          </div>
          <DatePicker
            visible={visible1}
            cancelText={t("QX")}
            confirmText={t("QD")}
            onClose={() => {
              setVisible1(false);
            }}
            precision="year"
            onConfirm={(val) => {
              setTime(moment(val).format("YYYY"));
            }}
          />
        </div>
        <div className={styles.meter_type_view}>
          <div
            className={styles.meter}
            style={{ width: i18n.language == "en" ? "25vw" : "20vw" }}
            onClick={() => {
              setVisible2(true);
            }}
          >
            <p style={{ color: "#010101" }}>{meterName}</p>
          </div>
          <Picker
            columns={meterOptions as any[]}
            visible={visible2}
            cancelText={t("QX")}
            confirmText={t("QD")}
            onClose={() => {
              setVisible2(false);
            }}
            value={meter}
            onConfirm={(v: any) => {
              let val = v[0];
              setMonitorId(val);
              const option = meterList.find(
                (item: Record<string, any>) => item.monitorid == val
              );
              setMeterName(coverMeterLabel(option.energyType));
            }}
          />
        </div>
      </div>

      {listElement}
    </div>
  );
}
